export const DIAGNOSIS_FETCH_REQUESTED = 'DIAGNOSIS_FETCH_REQUESTED';
export const DIAGNOSIS_FETCH_SUCCESS = 'DIAGNOSIS_FETCH_SUCCESS';

export const DIAGNOSIS_CLEAR_REQUESTED = 'DIAGNOSIS_CLEAR_REQUESTED';
